export const TableHead = () => {
  const template = `
    <thead>
      <tr>
        <th></th>
        <th>Firstname</th>
        <th>Lastname</th>
      </tr>
    </thead>
  `;

  return template;
};
